import Icon from '@ant-design/icons'
import { crmI18n } from '@crm/i18n'
import { AppNames } from '@shared/types'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useModules } from './useModules'

export const useMenuItems = () => {
  const { pathname } = useLocation()

  const enabled = pathname.startsWith(`/apps/${AppNames.Crm}`)

  const { modules } = useModules(enabled)

  const { t } = useTranslation('crm', {
    i18n: crmI18n,
    bindI18n: 'languageChanged languageChanging'
  })

  // Menu keys come from the module identifiers, not from the routes: a module
  // that only opens a submenu has no route, and ProLayout falls back to the
  // path when a key is missing — so every route-less module would collide on
  // the same key. Identifiers are also stable while the routes still load.
  const normalizedMenuItems = Object.keys(modules).map((module) => ({
    name: t(modules[module].label),
    key: module,
    path: modules[module].route,
    icon: <Icon component={modules[module].iconComponent} />,
    count: modules?.[module]?.count,
    params: modules[module].params,
    children: Object.keys(modules[module].children || {}).map((child) => ({
      name: t(modules[module].children?.[child].label || ''),
      key: `${module}/${child}`,
      path: modules[module].children?.[child].route,
      count: modules?.[module]?.children?.[child]?.count,
      params: modules[module].children?.[child].params
    }))
  }))

  return normalizedMenuItems || []
}
